<template>
    <section class="page-auth-registration">
        <div class="page-auth-registration__success"
            v-if="step === 'success'"
            >
            <div class="page-auth-registration__success-top">
                <div class="page-auth-registration__success-title"
                     v-text="'Регистрация прошла успешно!'"
                />
                <div class="page-auth-registration__success-text">
                    Теперь Вам доступен личный кабинет<br />
                    и подробная информация по объектам
                </div>
            </div>
            <div class="page-auth-registration__success-bottom">
                <div class="page-auth-registration__success-bottom-left">
                    <div class="page-auth-registration__success-bottom-description">
                        Изучите доступные для&nbsp;инвестиций объекты
                    </div>
                    <div class="page-auth-registration__success-button">
                        <ui-button
                            v-bind:href="urls.estates.list"
                            target="_self"
                            size="lg"
                            text="К объектам"
                        />
                    </div>
                </div>
                <div class="page-auth-registration__success-bottom-right">
                    <div class="page-auth-registration__success-bottom-description">
                        Пройдите верификацию, чтобы начать инвестировать —&nbsp;это займет всего несколько минут!
                    </div>
                    <div class="page-auth-registration__success-button">
                        <ui-button
                            v-bind:href="urls.cabinet.verification"
                            target="_self"
                            size="lg"
                            theme="secondary-2"
                            text="К верификации"
                        />
                    </div>
                </div>
            </div>
        </div>

        <template v-else>
            <div class="page-auth-registration__header">
                <h1>Регистрация</h1>
            </div>
            <div class="page-auth-registration__container">
                <div class="page-auth-registration__form">
                    <ui-form
                        v-bind:model="fields"
                        v-bind:validation="$v"
                        v-bind:submit-handler="registration"
                        v-on:update="updateFormData"
                    />
                </div>
                <div class="page-auth-registration__text _error"
                     v-if="emailExistsError"
                >
                    Указанный адрес электронной почты уже используется
                </div>
                <div class="page-auth-registration__text _error"
                     v-if="unknownError"
                >
                    Не удалось завершить регистрацию. Попробуйте ещё раз
                </div>
                <div class="page-auth-registration__button">
                    <ui-button
                        v-on:click="registration"
                        v-bind:disabled="emailExistsError"
                        size="lg"
                        text="Завершить регистрацию"
                    />
                </div>
            </div>
        </template>
    </section>
</template>

<script>
import { mapState } from 'vuex';
import config from '~/config';
import forms from '~/forms';

export default {
    name: 'page-auth-finish-registration',
    props: {
        content: {
            type: String,
            default: 'login-registration',
        },
    },
    data: () => ({
        step: 'form',
        recaptchaValue: null,
        urls: config.urls,
        existEmail: '',
        fields: {
            firstName: {
                ...forms.fields.fullName,
            },
            email: {
                ...forms.fields.email,
                label: 'Электронная почта',
            },
        },
    }),
    validations() {
        return {
            fields: {
                firstName: { ...forms.validations.registrationFullName },
                email: { ...forms.validations.email },
            },
        };
    },
    computed: {
        ...mapState('users', [
            'user',
            'getUserProfileResult',
            'getUserProfileIsLoading',

            'updateUserProfileIsLoading',
            'updateUserProfileError',
        ]),
        isLoading() {
            return this.getUserProfileIsLoading || this.updateUserProfileIsLoading;
        },
        emailExistsError() {
            return !!this.existEmail && this.existEmail === this.fields.email.value;
        },
        unknownError() {
            return this.updateUserProfileError !== ' Email exist' && !!this.updateUserProfileError;
        },
    },
    methods: {
        updateFormData(newData) {
            this.fields = newData;
        },
        registration() {
            if (this.$v.$invalid) {
                this.$v.$touch();
                return;
            }
            this.$store.dispatch('users/updateUserProfile', {
                firstName: this.fields.firstName.value,
                email: this.fields.email.value,
                onSuccess: () => {
                    this.$store.dispatch('users/getUserProfile');
                },
            });
        },
    },
    beforeMount() {
        this.$store.dispatch('users/getUserProfile');
    },
    watch: {
        getUserProfileIsLoading(newVal) {
            if (!newVal && this.getUserProfileResult && this.getUserProfileResult.email) {
                const back = new URLSearchParams(window.location.search).get('back');
                if (back) {
                    window.location.href = back;
                } else {
                    this.step = 'success';
                }
            }
        },
        updateUserProfileIsLoading() {
            if (this.updateUserProfileError === ' Email exist') {
                this.existEmail = this.fields.email.value;
            } else {
                this.existEmail = '';
            }
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-auth-registration {
    flex: 1 1 auto;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    flex-direction: column;
    &__header {
        position: relative;

        flex: 0 0 auto;
        padding-bottom: 8px;
        h1 {
            .typography-large();

            margin: 0;
            text-align: center;
        }
    }
    &__container {
        flex: 1 1 auto;
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        flex-direction: column;
    }
    &__text {
        .typography-body();

        margin-bottom: 16px;
        &._center {
            text-align: center;
        }
        &._error {
            color: @color-accent-negative;
            text-align: center;
            & > a {
                color: @color-primary;
                text-decoration: underline;
            }
        }
    }
    &__success {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 800px;

        border: 1px solid @color-gray-light-secondary;
        border-radius: 24px;
        text-align: center;
        overflow: hidden;

        &-title {
            .typography-large();

            margin-bottom: 12px;
            @media @media-md-down {
                margin-bottom: 32px;
            }
        }
        &-text {
            .typography-small();
        }
        &-top {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            min-height: 300px;

            background-image: url('~static/images/page-registration-success.jpg');
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
        }
        &-bottom {
            display: grid;
            grid-template-columns: 1fr 1fr;
            min-height: 240px;

            &-left {
                background-color: #F9F6FE;
                border-right: 1px solid @color-gray-light-secondary;
                color: @color-primary;
            }
            &-left,
            &-right {
                display: flex;
                flex-direction: column;
                overflow: hidden;
            }
            &-description {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;

                padding: 0 24px;

                .typography-medium();
            }
        }
        &-button {
            padding: 0 64px 44px 64px;
        }
    }
    &__form {
        flex: 0 0 auto;
        margin-bottom: 24px;
    }
    &__agreement {
        margin-bottom: 24px;
        &-error {
            .typography-body();

            margin-top: 16px;

            color: @color-accent-negative;
            text-align: center;
        }
    }
    &__recaptcha {
        flex: 0 0 auto;
        margin: 0 auto 40px;
        &-error {
            .typography-body();

            margin-top: 16px;

            color: @color-accent-negative;
            text-align: center;
        }
    }
    &__button {
        flex: 0 0 auto;
        min-width: 194px;
        margin: 0 auto 32px;
    }
    &__verification {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        margin-bottom: 40px;

        text-align: center;
        &-password {
            margin-bottom: 16px;
        }
        &-help {
            .typography-body();

            margin-top: 8px;

            text-align: center;
            &-trigger {
                cursor: pointer;

                color: @color-primary;
                text-decoration: underline;
                &:hover {
                    text-decoration: none;
                }
            }
            &-timer {
                display: inline-block;
                min-width: 40px;

                color: @color-primary;
                text-align: left;
            }
        }
    }
    &__login {
        .typography-body();

        flex: 0 0 auto;
        margin: auto 0 0;

        text-align: center;
        & a {
            color: @color-primary;
        }
    }

    @media @media-md-down {
        &__container {
            .container-paddings();

            padding-bottom: 32px;
        }
        &__success {
            width: 98%;

            &-title {
                .typography-medium();

                margin-bottom: 12px;
            }
            &-text {
                .typography-heading();
            }
            &-top {
                min-height: 240px;
            }
            &-bottom {
                &-description {
                    padding: 0 12px;
                    .typography-heading();
                }
            }
            &-button {
                padding: 0 12px 24px 12px;
            }
        }
    }
    @media @media-xs-down {
        &__button {
            width: 100%;
        }
    }
}
</style>
